import { Fragment } from 'react';

// Components
import Grid from '@material-ui/core/Grid';
import DataTable from 'components/CncUI/DataTable';
import Typography from 'components/CncUI/Typography';

const SuccessRecords = props => {
  const { records, loading } = props;

  const columns = [
    {
      field: 'email',
    },
    {
      field: 'loginId',
      label: 'Okta ID',
    },
    {
      field: 'data',
      sortable: false,
      value: ({ data }) => {
        const keys = Object.keys(data);
        return keys.map(key => (
          <Fragment key={`data-${key}`}>
            <b>{key}</b>
            {`: ${data[key]}`}
            <br />
          </Fragment>
        ));
      },
    },
  ];

  const information = (records || []).map(status => ({
    email: status.email,
    loginId: status.loginId,
    data: {
      profileCompleted: status.profileCompleted,
      capsProfileCompleted: status.capsProfileCompleted,
      verified: status.verified,
      cncProfile: status.cncProfile,
      capsProfile: status.capsProfile,
      canProfile: status.canProfile,
    },
  }));

  return (
    <Grid container spacing={0}>
      <Grid item xs={12}>
        <Typography variant="h5">Registration Process Report</Typography>
      </Grid>
      <Grid item xs={12}>
        <DataTable
          transparent
          pageSize={5}
          columns={columns}
          data={loading ? [] : information}
        />
      </Grid>
    </Grid>
  );
};

export default SuccessRecords;
